export default __webpack_public_path__ + "static/media/Nilesh.eccc1e0d.jpeg";